import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcesses(customer_id) {
    return RequesterV1.get(
      `customer/quality_reports/container_provider/${customer_id}/list_processes`
    );
  },
};
